import { FC } from 'react';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { FormattedMessage } from 'react-intl';
import WhatsappSvg from '#srcIcons/socials/whatsapp.svg';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { Button, ButtonVariant } from '#components/button';
import { SocialLinkAlias } from '#components/social-link';
import modelDetailContactButtonListCss from '../../assets/model-detail/model-detail-contact-button-list.module.scss';

const Whatsapp: FC = () => {
  const {
    advert: {
      contactData,
    },
  } = useAdvertDetailContext();

  if (!contactData.socialLinkList) {
    return null;
  }

  const whatsapp = contactData.socialLinkList.find((socialLink) => socialLink.alias === SocialLinkAlias.whatsApp);

  if (!whatsapp) {
    return null;
  }

  return (
    <Button
      variant={ButtonVariant.greenLight}
      fontWeight600
      linkSimpleProps={{
        href: whatsapp.url,
        target: '_blank',
        rel: 'noreferrer',
      }}
      contentAdditionalClassName={modelDetailContactButtonListCss.modelDetailContactButtonList__itemContent}
      additionalClassName={modelDetailContactButtonListCss.modelDetailContactButtonList__item}
    >
      <SvgIcon Component={WhatsappSvg} size={16} colored />
      <FormattedMessage defaultMessage="WhatsApp" />
    </Button>
  );
};

export { Whatsapp };
